"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

import { supportConfig } from "@/config/support-config";
import {
  COOKIE_CONSENT_UPDATED_EVENT,
  getCookieConsent,
} from "@/libs/cookie-consent";

const isProd = process.env.NODE_ENV === "production";

export const Support = () => {
  const [hasSupportConsent, setHasSupportConsent] = useState(false);

  useEffect(() => {
    const syncConsent = () => {
      const consent = getCookieConsent();
      setHasSupportConsent(Boolean(consent?.support));
    };

    syncConsent();
    window.addEventListener(COOKIE_CONSENT_UPDATED_EVENT, syncConsent);
    return () => window.removeEventListener(COOKIE_CONSENT_UPDATED_EVENT, syncConsent);
  }, []);

  if (!isProd) {
    return null;
  }

  if (isProd && supportConfig.crispId && hasSupportConsent) {
    const Crisp = dynamic(() => import("./crisp"), {
      ssr: false,
    });

    return <Crisp />;
  }

  return null;
};
